import { Box, Grid, Paper, Stack } from '@mui/material'
import { Editor, EditorProps, initialBlockStyle, initialStyleMap } from 'contenido'
import 'contenido/dist/styles.css'
import Draft, { ContentBlock } from 'draft-js'
import Immutable from 'immutable'
import CaptionEditorComponent from './edit/CaptionEditorComponent'

// Types
import type { FC } from 'react'

const blockStyleFn = (block: ContentBlock, customBlockStyles?: { [key: string]: string }[] | undefined): string => {
  const blockAlignment = block.getData() && block.getData().get('text-align')
  let textAligment = ''
  if (blockAlignment) {
    textAligment = `text-align-${blockAlignment}`
  }

  const blockType = block.getType()
  let blockStyles = initialBlockStyle

  if (customBlockStyles && customBlockStyles?.length > 0) {
    customBlockStyles.forEach(blockStyle => (blockStyles = { ...blockStyles, ...blockStyle }))
  }

  return `${textAligment} ${blockStyles[blockType || 'unstyled'] || ''}`.trim()
}

const blockRenderMap = Immutable.Map({
  'header-one': {
    // element is used during paste or html conversion to auto match your component;
    // it is also retained as part of this.props.children and not stripped out
    element: 'h1',
    wrapper: <CaptionEditorComponent />
  }
})

const extendedBlockRenderMap = Draft.DefaultDraftBlockRenderMap.merge(blockRenderMap)

const ContentRendererComponent: FC<EditorProps> = props => {
  const { editorState, onChange } = props

  return (
    <Grid container>
      <Paper
        sx={({ shadows, breakpoints }) => ({
          display: 'flex',
          flexGrow: 1,
          boxShadow: shadows[6],
          position: 'relative',
          [breakpoints.up('md')]: {
            p: 1
          },
          [breakpoints.up('xs')]: {
            p: 0
          }
        })}
      >
        <Stack
          direction='column'
          alignItems='flex-start'
          spacing={2}
          sx={({ breakpoints }) => ({
            p: 4,
            [breakpoints.down('sm')]: { p: 2 }
          })}
          flexGrow={1}
        >
          <Box
            dir='auto'
            sx={({ breakpoints }) => ({
              borderRadius: '1rem',
              border: '1px solid',
              borderColor: 'divider',
              width: '100%',
              px: 8,
              pb: 8,
              overflow: 'auto',
              cursor: 'text',
              [breakpoints.down('sm')]: { px: '0.75rem', pb: '0.75rem' }
            })}
          >
            <Editor
              editorState={editorState}
              onChange={onChange}
              customStyleMap={initialStyleMap}
              blockRenderMap={extendedBlockRenderMap}
              blockStyleFn={blockStyleFn}
            />
          </Box>
        </Stack>
      </Paper>
    </Grid>
  )
}

export default ContentRendererComponent
